import React from "react";
import { Link, useNavigate } from "react-router-dom";
import PublicLayout from "@/components/layout/PublicLayout";
import { useCart } from "@/contexts/CartContext";
import { CartBody, money } from "@/components/marketplace/CartDrawer";
import { ArrowLeft } from "lucide-react";

export default function CartPage() {
  const { items, quote } = useCart();
  const navigate = useNavigate();
  return (
    <PublicLayout>
      <div className="max-w-3xl mx-auto px-4 py-8" data-testid="cart-page">
        <Link to="/marketplace/products" className="inline-flex items-center gap-1 text-sm text-slate-500 hover:text-[#E63946]"><ArrowLeft className="w-4 h-4" /> Continue shopping</Link>
        <h1 className="font-display text-3xl uppercase tracking-tight mt-3">Your Cart</h1>
        <div className="mt-6"><CartBody /></div>
        {items.length > 0 && (
          <button data-testid="cart-page-checkout" onClick={() => navigate("/marketplace/checkout")} disabled={!quote?.total_cents}
            className="w-full mt-6 bg-[#E63946] hover:bg-[#c62f3b] disabled:opacity-50 text-white py-3.5 text-sm font-semibold uppercase tracking-wider rounded-sm transition-colors">
            Proceed to Checkout · {money(quote?.total_cents)}
          </button>
        )}
      </div>
    </PublicLayout>
  );
}
